import Chip from "@web-ui/components/Chip";
import Icon from "@web-ui/components/Icon";
import type { UploadState } from "./states";

/**
 * A video's state as a chip with an icon and a word (never colour alone), and its one-line
 * explanation under it ("Your Mac encodes videos…"). The tones are the fixed status ones.
 */
const ICON: Record<UploadState["key"], string> = { uploading: "upload", waiting: "hourglass", encoding: "clock", ready: "check-circle", failed: "close-circle" };
const FILL: Record<UploadState["tone"], string> = { neutral: "fill-t-tertiary", warning: "fill-warning", positive: "fill-positive-stroke", critical: "fill-critical" };

export function UploadStateChip({ state }: { state: UploadState }) {
  return (
    <Chip size="sm">
      <span className="inline-flex items-center gap-1" data-state={state.key}>
        <Icon name={ICON[state.key]} size={4} className={FILL[state.tone]} />
        {state.label}
      </span>
    </Chip>
  );
}

export function UploadStateLine({ state, showDetail = true }: { state: UploadState; showDetail?: boolean }) {
  return (
    <div className="flex flex-col gap-1" role="status" aria-live="polite">
      <div className="flex flex-wrap items-center gap-2">
        <UploadStateChip state={state} />
        {typeof state.progress === "number" ? (
          <span className="h-1.5 w-32 overflow-hidden rounded-full bg-b-surface3" aria-hidden="true">
            <span className="block h-full rounded-full bg-accent transition-[width]" style={{ width: `${Math.round(state.progress * 100)}%` }} />
          </span>
        ) : null}
      </div>
      {showDetail ? <p className="text-caption text-t-secondary">{state.detail}</p> : null}
    </div>
  );
}
